import { Button, Space } from "antd";
import { PageHeader } from '@ant-design/pro-components';

import {
  CheckOutlined,
  ClearOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { hasPermissao, Papel } from "../../../auth/entidadeUsuario";
import { mostrarInfo } from "../../../utils/messages";
import { modalApi } from "../../../config/AntdGlobalProvider";

const CadInfoBotoes = (props: any) => {
  const navigate = useNavigate();

  function mostrarConfirmar() {
    if (!props.verificaItensObrigatorios()) {
      mostrarInfo("Erro ao submeter formulário", "A pessoa física deve apresentar pelo menos um documento e um endereço pessoal válido.");
    } else {
      modalApi.confirm({
        title: props.manter === 1 ? "Deseja confirmar o cadastro?" : "Deseja confirmar as alterações?",
        width: "700px",
        icon: <ExclamationCircleOutlined />,
        content: props.form.getFieldValue("nuCpf") + ": " + props.form.getFieldValue("nmPessoaFisica"),
        okButtonProps: { id: 'ok' },
        onOk() {
          props.form.validateFields();
          window.scrollTo(0, 0)
          props.form.submit();
        },
        onCancel() { },
      });
    }

  }


  function mostrarConfirmarCancelar(novoManter : number) {
    modalApi.confirm({
      title: novoManter === -1 ? "Deseja cancelar a inclusão?" : "Deseja cancelar a edição?",
      width: "700px",
      icon: <ExclamationCircleOutlined />,
      content: novoManter === -1 ? "Todos os dados serão perdidos" : "Todos os dados alterados serão perdidos",
      okButtonProps: { id: 'ok' },
      onOk() {
        props.setManter(novoManter);
        window.scrollTo(0, 0)
      },
      onCancel() { },
    });
  }

  function mostrarConfirmarNovaConsulta() {
    if (props.manter === 3) {
      modalApi.confirm({
        title: props.manter === 1 ? "Cancelar edição?" : "Esta ação irá cancelar a edição. Deseja continuar?",
        width: "700px",
        icon: <ExclamationCircleOutlined />,
        content: "Todos os dados alterados serão perdidos",
        okButtonProps: { id: 'ok' },
        onOk() {
          novaConsulta();
        },
        onCancel() { },
      });
    } else {
      novaConsulta();
    }
  }

  function novaConsulta() {
      navigate("/pessoa-fisica/consultar");
    // props.setManter(-1); // ESTADO INICIAL
    // limparCamposDesabilitar();
    // props.resetColor();
    // window.scrollTo(0, 0)
  }

  return (
    <>
      <PageHeader
        className='site-page-header'
        style={{ background: "#FFF" }}
        extra={
          <div
            style={{
              display: "flex",
              width: "max-content",
              justifyContent: "flex-end",
            }}
          >
            <Space>
              <Button
                style={{ display: props.manter >= 2 ? "inline" : "none" }} // SOMENTE DETALHE E EDIÇÃO
                shape='round'
                onClick={() => {
                  mostrarConfirmarNovaConsulta();
                }}
                icon={<ClearOutlined />}
              >
                Nova consulta
              </Button>

              <Button
                disabled={props.manter === 1 ? props.desabilitaBotoes() : false}
                style={{ display: (props.manter === 1 || props.manter === 3) ? "inline" : "none" }} // INCLUSÃO OU EDIÇÃO
                shape='round'
                onClick={() => {
                  mostrarConfirmarCancelar( props.manter === 1 ? -1 : 2);
                }}
                icon={<ClearOutlined />}
              >
                { props.manter === 1 ? "Cancelar" : "Cancelar edição"}
              </Button>

              <Button
                style={{ display: props.manter === 2 && hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO, Papel.DICOL_CGDC, Papel.DIFIS_CGRE, Papel.ENTIDADE_ALTERAR]) ? "inline" : "none" }}
                shape='round'
                onClick={() => {
                  props.setManter(3);
                }}
                type='primary'
                icon={<CheckOutlined />}
              >
                Editar
              </Button>

              <Button
                disabled={props.manter === 1 ? props.desabilitaBotoes() : false}
                // disabled={false}
                style={{ display: (props.manter === 1 || props.manter === 3) ? "inline" : "none" }} // INSERIR OU ALTERAR
                shape='round'
                onClick={() => {
                  props.resetColor();
                  mostrarConfirmar();
                }}
                type='primary'
                icon={<CheckOutlined />}
              >
                Salvar
              </Button>

            </Space>
          </div>
        }
      />
    </>
  );
};

export default CadInfoBotoes;
